import React, { useState } from "react";

export default function LiquidGlass({
  filterId = "liquid-glass",
  className = "",
  style = {},
  isAnimating = true,
  glassColor = {
    from: "from-white/25",
    via: "via-white/15",
    to: "to-white/10",
    overlayFrom: "from-blue-400/20",
    overlayVia: "via-purple-400/15",
    overlayTo: "to-pink-400/10",
    glowFrom: "from-white/10",
    glowTo: "to-transparent",
  },
  contentClassName = "",
  children,
}) {
  const [noisePhase] = useState(Math.random());

  return (
    <div className={`relative overflow-hidden ${className}`} style={style}>
      {/* SVG filter definition */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none z-0"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id={filterId} x="-10%" y="-10%" width="120%" height="120%">
            <feTurbulence
              type="fractalNoise"
              numOctaves="2"
              seed="3"
              result="turbulence"
              baseFrequency={`${0.008} ${0.008 + noisePhase * 0.003}`}
            />
            <feDisplacementMap in="SourceGraphic" in2="turbulence" scale="2" />
            <feGaussianBlur stdDeviation="0.2" />
          </filter>
        </defs>
      </svg>

      {/* Filtered animation layer (no text blur) */}
      {isAnimating && (
        <div
          className="absolute inset-0 rounded-2xl pointer-events-none"
          style={{
            filter: `url(#${filterId})`,
            zIndex: 0.5,
          }}
        />
      )}

      {/* Glass base gradient */}
      <div
        className={`absolute inset-0 bg-gradient-to-br ${glassColor.from} ${glassColor.via} ${glassColor.to} rounded-2xl backdrop-blur-sm pointer-events-none`}
        style={{ zIndex: 1 }}
      />

      {/* Color overlay */}
      <div
        className={`absolute inset-0 bg-gradient-to-br ${glassColor.overlayFrom} ${glassColor.overlayVia} ${glassColor.overlayTo} rounded-2xl pointer-events-none`}
        style={{ zIndex: 2 }}
      />

      {/* White inner border */}
      <div
        className="absolute inset-0 rounded-2xl ring-1 ring-white/30 ring-inset pointer-events-none"
        style={{ zIndex: 3 }}
      />

      {/* Glow layer */}
      <div
        className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${glassColor.glowFrom} ${glassColor.glowTo} pointer-events-none`}
        style={{ zIndex: 4 }}
      />

      {/* Main content (no filter applied) */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
        }}
        className={contentClassName}
      >
        {children}
      </div>
    </div>
  );
}
